import {h, Fragment} from "preact"
export default function Checkbox({ value, selected, onChange, className }) {
    return (
        <label className={`ns-checkbox ns-d-block ns-color-black ${className}`} title={value}>
            {value}
            <input type="checkbox" checked={selected} onChange={onChange} />
            <span className="ns-checkmark">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.59889 9.42469L13.75 1.27358L12.4764 0L4.32531 8.15111L5.59889 9.42469Z" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.61787 8.40543L1.52358 3.31114L0.25 4.58472L5.34429 9.67901L6.61787 8.40543Z" fill="white"/>
                </svg>
            </span>
        </label>
    )
}